import React from "react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";


export default function LeadershipToolkit() {
  return (
    <BackgroundWrapper>
      
      <div className="pt-8 pb-20 px-4 min-h-screen flex justify-center">
        <div className="max-w-5xl bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-8 md:p-12">
          <Link
            to="/programs"
            className="mb-8 inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold"
          >
            ← Back to Programs
          </Link>

          <h1 className="text-xl sm:text-2xl font-bold text-slate-800 mb-8 text-center">
            The Leadership Toolkit
          </h1>

          <p className="sm:text-lg text-sm text-slate-700 mb-6 leading-relaxed">
            Designed to help <strong>senior executives develop into leaders</strong>,
            this program builds the skills necessary to ignite self and others, engage the public,
            and influence stakeholders at the highest levels.
          </p>

          <h3 className="text-2xl font-semibold text-slate-800 mb-4 text-xl sm:text-2xl">The Content</h3>
          <ul className="list-disc list-inside text-slate-700 mb-6 space-y-1 sm:text-lg text-sm">
            <li>Dealing with public engagements and communication</li>
            <li>Developing ideas and rallying people around them</li>
            <li>Creating momentum and energy to achieve great outcomes</li>
            <li>Advanced senior-level communication including media and public speaking</li>
            <li>Managing stakeholders with a 360° perspective</li>
          </ul>

          <h3 className="text-2xl font-semibold text-slate-800 mb-4 text-xl sm:text-2xl">The Format</h3>
          <p className="text-slate-700 mb-6 sm:text-lg text-sm">
            Delivered through a blend of <strong>seminars</strong> and <strong>individual coaching</strong> sessions.
            Accredited internationally and recognized for Continuing Professional Development (CPD).
          </p>
        </div>
      </div>
    </BackgroundWrapper>
  );
}
